const Theme = {
  card_background_color: '1c1c1c',

  header_background_color: '#1c1c1c',
  logo_image_url: 'zombiesmtl.png',

  body_background_color: '#1c1c1c',

  button_color: '#34b076',
  button_radius: 14,

  text_color: 'white',
  title_color: '#00bae7',

  popup_text_color: 'black',
}

export default Theme
